import React, { useEffect } from 'react';
import Swiper from 'swiper';
import api from '../plugin/api.js';
import "../Assets/js/testjsxfunction.js";
import "../Assets/js/generalui.js";

import GoogleLogin from '../components/GoogleLogin.jsx';

// import { Player } from '@lottiefiles/react-lottie-player';
// import { createRoot } from 'react-dom/client';


import '../Assets/css/testcss.css'
import  '../Assets/js/testscript.js'

// import {
//   initAuthListener,
//   loginWithGoogle,
//   logout,
//   getToken,
//   getCurrentUser,
//   deleteAccount,
//   initAuthSystem
// } from '../plugin/firebase';

import {
  initAuth,
  loginauthservice,
  logoutauthservice,
  deleteAccount,
  getSession,
  getToken,
  getUser
} from "../plugin/authService.js";


function TestInfiniteScroll()
{
  const loadBooking = async (uuid) =>
  {
    const res = await fetch(`https://beta.api.pingingo.com/v2/bookings/${uuid}`,
    {
      method: "GET",
      credentials: "include",
      headers:
      {
        "Accept": "application/json",
        "Origin": "https://pingingo.com",
        "x-access-key":"faf2bf0b-162b-4ba5-9a6d-8160375ad48d"
      }
    });

    return res.json();
  };

  const LoadBanner = async () =>
  {
    const res = await fetch("https://beta.api.pingingo.com/v2/banners/pop-up",
    {
      method: "GET",
      credentials: "include",
      headers:
      {
        "Accept": "application/json",
        "x-api-key":"J0NR30CRoDIa2VtwmUeTxHCH1jlQK3sQ"
      }
    });

    return res.json();
  };

  useEffect(() =>
  {
    // window.loadBooking = loadBooking;
    // window.LoadBanner = LoadBanner;
    window.PrepareTestInstantiate();
    document.getElementById("IdTransactionInput").value = "f8739240-35d8-49e3-9bbc-fd58549c7559";
    window.TestFunction();
    // api.get("/access/bookings/83090476-eac8-11f0-b9a9-2047479213e0")
    // .then(res => {
    //   //console.log(res);
      
    // })
    // .catch(err => {
    //   //console.error(err);
    // });

    // api.get("/access/debug-headers")
    // .then(res => {
    //   //console.log(res);
      
    // })
    // .catch(err => {
    //   //console.error(err);
    // });

    // ================ FIRE BASE RELATED ==========================

    // initAuthListener((data) =>
    // {
    //   //console.log("FULL AUTH DATA:", data);
    //   //console.log(getCurrentUser()); 

    // });

    // initAuthSystem((data) =>
    // {
    //   if (!data) {
    //     // not logged in
    //     return;
    //   }

    //   //console.log("Firebase user:", data.sessionUser);
    //   //console.log("Backend user:", data.backendUser);
    //   //console.log("Token:", data.token);
    // });

    var swiper = new window.Swiper(".mySwiper",
    {
      direction: "vertical",
      slidesPerView: 1,
      mousewheel: true, // Optional: enables scroll wheel navigation
    });



  }, []);

  return (
    <div className="container">
        <div className="Navbar">
            <button className="BackButton">←</button>
            <span id="NavbarTitle"></span>
        </div>

        <div className="Banner">
            Hotel Images
        </div>

        <div id="HotelTitle" className="HotelTitle">
            <h2>D'Limasan Cottage</h2>
            <p>Uluwatu, Bali</p>
        </div>

        <div className="Section">
            <h3>Facilities</h3>
            <p>Lorem ipsum...</p>
        </div>

        <div className="Section">
            <h3>Description</h3>
            <p>
                Lorem ipsum dolor sit amet...
                <br/><br/>
                Lorem ipsum dolor sit amet...
                <br/><br/>
                Lorem ipsum dolor sit amet...
                <br/><br/>
                Lorem ipsum dolor sit amet...
                <br/><br/>
                Lorem ipsum dolor sit amet...
            </p>
        </div>

        <div id="BookingSection" className="BookingSection">
            <h3>Pilih Kamar</h3>
            <button>Ubah</button>
        </div>

        <div className="Section">
            <h3>Rooms</h3>

            <div className="Room"></div>
            <div className="Room"></div>
            <div className="Room"></div>
            <div className="Room"></div>
            <div className="Room"></div>
        </div>

        <div className="swiper mySwiper">
          <div className="swiper-wrapper">
            <div className="swiper-slide">Slide 1</div>
            <div className="swiper-slide">Slide 2</div>
            <div className="swiper-slide">Slide 3</div>
          </div>
        </div>


        <div id="StickyBookingBar" className="StickyBookingBar">
            <strong>Pilih Kamar</strong>

            <button>Ubah</button>
        </div>

        <script src="script.js"></script>

        <h1>Test Page</h1>
        <div className="swiper hotelSwiper" id='SampleHotelSwiper'>
          <div className="swiper-wrapper"></div>
        </div>
        <div>
          <h1>Login</h1>
          <div>
            <button onClick={() => loginauthservice("google", null, null)}>Login with Google</button>

            <button onClick={() => loginauthservice("pingingo",{
              email: "yosiadanielo@gmail.com",
              password: "Test@123"
            }, null)}>
              Login with Email
            </button>
          </div>
          <div>
            <button onClick={logoutauthservice}>
              Logout
            </button>

            <button onClick={deleteAccount} style={{ color: "red" }}>
              Delete Account
            </button>
          </div>
        </div>
        <div style={{backgroundColor:"grey", padding:"20px", width:"500px"}}>
            <p>Test Send Email</p>
            <input type="text" id="IdTransactionInput" style={{width:"90%"}} />
            <button onClick={()=>window.TestSendEmailTemplate('waiting')}>Send Waiting Payment</button>
            <button onClick={()=>window.TestSendEmailTemplate('success')}>Send Success</button>
            <button onClick={()=>window.TestSendEmailTemplate('timeout')}>Send Timeout</button>
            <button onClick={()=>window.TestSendEmailTemplate('BookingConfirmed')}>Booking Confirmed</button>
            <button onClick={()=>window.TestSendEmailTemplate('BookingCompleted')}>Booking Completed</button>
        </div>
        <div id="container" className="container"></div>
        
        {/* <dotlottie-wc src="/Assets/images/lottieanim/cross.json" speed="1" style={{width: "300px", height: "300px"}} mode="forward"loopautoplay></dotlottie-wc> */}

    </div>



  )
}

export default TestInfiniteScroll